/* ─── UPCOMING EVENTS ─── */
import Social from "../../../../../assets/Socials/social1.jpg"

const upcomingEvents = [

  {
    id: "upcoming-1",
    title: "Power Networking Brunch",
    banner: null,

    location: "XO & MI, Le Meridien Hotel, Janpath, New Delhi",
    date: "April 18, 2026",
    time: "12:30 PM",

    shortDescription:
      "Join us for meaningful networking with connections that matter. Enjoy international cuisines with wine & beer over warm conversations.",

    highlights: [
      "✔ Networking brunch with curated guest list",
      "✔ International cuisines with wine & beer",
      "✔ Premium venue at XO & MI, Le Meridien",
      "✔ Connect with professionals and industry leaders",
      "✔ Private event – by invite only",
    ],

    category: "Networking Event",
    isPrivate: true,
    scriptUrl:"https://script.google.com/macros/s/AKfycbyC-mBBOQH1vImNX-6MRCFcmIKNnfrqArM5wYrtM5jEpRt8M5tVjFiorJb-Z8Y9VNAO/exec",
  locationlink:"https://maps.app.goo.gl/YtP9R4kbJAUsodGeA"
}
];

/* ─── PAST EVENTS — keep original structure (title, description, points, video) ─── */
const pastEvents = [
  {
    id: "past-1",
    title: "Heritage Transport Museum Visit",
    description:
      "The first IHN Social brought members and guests together at the iconic Heritage Transport Museum near Manesar. This inaugural social set the foundation for future IHN gatherings by blending culture, leisure, and meaningful networking.",
    points: [
      "Guided museum walkthrough",
      "Interactive exhibits & experiences",
      "Networking over lunch and conversations",
    ],
    location: "Manesar, Haryana",
    date: "March 15, 2024",
    video: "https://www.youtube.com/embed/luH_Bm9qDno",
  },
  {
    id: "past-2",
    title: "Featuring Tejbir Anand",
    description:
      "Since 1997, Tejbir leads India's Adventure & Tourism sector, founding Holiday Moods Adventures and Camp Wild Dhauj, and serving key roles in the Adventure Tour Operators Association.",
    points: [
      "Founding Board Member & Vice Chairman of FAITH Tourism",
      "Ventured into Polar Cruises distribution",
      "Provides full B2B Destination Management support for Polar countries",
      "Regular participant in top industry events alongside his business partner Arshdeep Anand",
      "Honoured guest at IHN Network Multiplier event, May 26, 2023, Qutub Golf Course, Delhi",
    ],
    location: "Qutub Golf Course, Delhi",
    date: "May 26, 2023",
    video: "https://www.youtube.com/embed/Nx-A3aYAsB4",
  },
];

export { upcomingEvents, pastEvents };